import React, { useState, useEffect, useRef } from "react";
import { IonItem, IonLabel, IonSelect, IonSelectOption } from "@ionic/react";
import "./DropdownComponent.scss";
import _ from "lodash";
import { useTranslation } from "react-i18next";


/**
 * Drop down component
 * Component will show a drop down to select from list.
 * Component will return the selectd item id.
 */
interface ListModal {
  dataId: number;
  dataName: string;
  default: boolean;
}

interface DropDownItemProps {
  fromFav: boolean;
  siteListData: ListModal[];
  getSelectedItem: (value: number, key?: any, defaultVal?: boolean) => void;
  enableMultipleSelection?: boolean;
  favCardData?: any;
  isFromTeams?: boolean;
  selectedSiteData?: any;
  value?: any;
  dropDownValue?: any;
  selectedValue?: any
}

const NetworkDropDown: React.FC<DropDownItemProps> = (props) => {
  const { t } = useTranslation("header");
  const [hospitalId, setHospitalId] = useState<string | number>(""); // not Number
  const userInteractedRef = useRef(false);
  useEffect(() => { }, []);

  useEffect(() => {
    setFavCardSite();
    if (props.isFromTeams) {
      setSelectedSite();
    }
  }, [props.siteListData]);

  const setSelectedSite = () => {
    props.getSelectedItem(props.selectedSiteData);
    setHospitalId(props.selectedSiteData);
  };

const setFavCardSite = () => {
  if (!_.isEmpty(props.favCardData)) {
    const { network, network_id } = props.favCardData.params || {};
    // props.getSelectedItem(network, network_id, false);
    setHospitalId(network); // or network_id depending on what IonSelectOption uses
  }
};


  const getValue = () => {
    if (props.dropDownValue === "Select age") {
      return props.dropDownValue;
    } else if (props.dropDownValue === "Select ETA") {
      return props.dropDownValue;
    } else if (props.dropDownValue === "Select Unit") {
      return props.dropDownValue;
    } else if (props.dropDownValue === "Select age unit") {
      return props.dropDownValue;
    } else if (props.dropDownValue === "Select Network") {
      return props.dropDownValue;
    }
    else {
      return "Sites";
    }
  };
  console.log(props.selectedValue, "tyruei")
  const getByPlaceholderText = () => {
    if (props.dropDownValue === "Select age") {
      return "-- Select age --";
    } else if (props.dropDownValue === "Select ETA") {
      return "-- Select ETA --";
    } else if (props.dropDownValue === "Select unit") {
      return "-- Select unit --";
    } else if (props.dropDownValue === "Select age unit") {
      return "-- Select age unit --";
    } else if (props.dropDownValue === "Select Network") {
      return "-- Select Network --";
    }
    else {
      return "-- Select Site --";
    }
  };
console.log(props,"props network comp")
  return (
    <IonItem className={`${props.fromFav ? "favsite-dropdown" : "site-dropdown"
        }${props.isFromTeams ? " teams-site" : ""}`}
    >
      <IonSelect
        okText="Done"
        onClick={() => (userInteractedRef.current = true)}
        cancelText={t("cancel")}
        value={props.selectedValue?.value || hospitalId}
      onIonChange={(e) => {
        if (!userInteractedRef.current) return;
  const selectedDataName = e.detail.value;
  const selectedItem = props.siteListData.find(item => item.dataName === selectedDataName);
  if (selectedItem) {
    props.getSelectedItem(
      selectedItem.dataName,
      selectedItem.dataId,
      selectedItem.default
    );
    setHospitalId(selectedItem.dataName);
  }
}}
        placeholder={getByPlaceholderText()}
        multiple={props.enableMultipleSelection ?? false}
      >
        <IonLabel>{getValue()}</IonLabel>

        {props.siteListData.map((item) => (
        <IonSelectOption value={item.dataName} key={item.dataId}>
  {item.dataName}
</IonSelectOption>
        ))}
      </IonSelect>
    </IonItem>
  );
};

export default NetworkDropDown;
